import { Visibility } from '../modules/authentication'
import Button from './Button'
import Dropdown from './Dropdown'
import { EllipsisCircle } from '../icons'
import DropdownItem from './DropdownItem'
import actionsPropTypes from '../prop-types/actionsPropTypes'

function HeaderActions({ actions }) {
  return (
    <>
      <div className="hidden sm:flex sm:flex-row-reverse sm:mt-0 sm:ml-4 sm:space-x-2 sm:space-x-reverse">
        {actions.map(({
          key, permissions, permissionsWithRegex, ...action
        }) => (
          <Visibility key={key} permissions={permissions} permissionsWithRegex={permissionsWithRegex}>
            <Button
              small
              {...action /* eslint-disable-line react/jsx-props-no-spreading */}
            />
          </Visibility>
        ))}
      </div>
      <div className="sm:hidden flex-shrink-0">
        {actions && actions.length > 1 && (
        <Dropdown
          buttonProps={{
            primary: true,
            small: true,
          }}
          icon={<EllipsisCircle />}
          alignRight
        >
          {actions.map(({
            permissions, permissionsWithRegex, key, ...action
          }) => (
            <Visibility key={key} permissions={permissions} permissionsWithRegex={permissionsWithRegex}>
              <DropdownItem
                {...action /* eslint-disable-line react/jsx-props-no-spreading */}
              />
            </Visibility>
          ))}
        </Dropdown>
        )}
        {actions && actions.length <= 1 && ((actions.map(({
          permissions, permissionsWithRegex, key, children: c, ...action
        }) => (
          <Visibility key={key} permissions={permissions} permissionsWithRegex={permissionsWithRegex}>
            <Button
              neutral={!action.primary}
              {...action /* eslint-disable-line react/jsx-props-no-spreading */}
              title={c}
            />
          </Visibility>
        )))
        )}
      </div>
    </>
  )
}

HeaderActions.propTypes = {
  actions: actionsPropTypes.isRequired,
}

export default HeaderActions
